import { Data2, newId } from '../../../features/data-types'
import { useSystemStateHooks } from '../../system'
import { ExpenseType } from '../state/types'

export const useExpenseTypeBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildExpenseType = (data: Data2) => {
        const { id = newId(), name, archived } = data
        const expenseType: ExpenseType = {
            companyId: companyId!,
            id: id! as string,
            name: name! as string,
            archived: !!archived
        }

        return expenseType
    }

    return {
        buildExpenseType
    }
}
